import React, { useRef, useState, useEffect } from 'react';
import SectionTitle from './SectionTitle';
import { Download } from 'lucide-react';
import './ImpactSection.css';

const impactData = [
  {
    isCircle: true,
    title: 'सार्वजनिक जीवन के 25 वर्ष',
    short: 'स्वदेशी काम करनेवाला "परदेशी" व्यक्ति',
  },
  {
    title: 'भारत की संपूर्ण नई न्याय व्यवस्था',
    short: 'लोगोको त्वरित न्याय देना है, सबुत के आधार पर नही। ',
    pdfFile: '/images/न्याय-व्यवस्था-प्रारूप.pdf'
  },
  {
    title: 'भारत-की-संपूर्ण-नई-शिक्षा-व्यवस्था',
    short: 'एक भारत, श्रेष्ठ भारत बनाने के लिए एकसमान, व्यावहारिक, आधुनिक और सक्षम शिक्षा व्यवस्था स्थापित हो।',
    pdfFile: '/images/भारत-की-संपूर्ण-नई-शिक्षा-व्यवस्था.pdf'
  },
  {
    title: 'एक देश, एक चुनाव',
    short: 'विकसित और अनुशासित हिंदुस्थान बने।',
    pdfFile: '/images/एक-देश-एक-चुनाव.pdf'
  },
  {
    title: ' व्यक्तिगत और सामाजिक विचारधारा बदलनेका प्रारूप ',
    short: 'एकत्रित, संतुलित, स्वाभिमानी और निडर हिन्दू समाज बने',
    pdfFile: '/images/व्यक्तिगत-और-सामाजिक-विचारधारा-बदलनेका-प्रारूप.pdf'
  },
  {
    title: 'सड़क सुरक्षा के लिए विशेष योजना',
    short: 'संपूर्ण भारत सड़क व यातायात योजना के माध्यम से दुर्घटनाओं में कमी।',
    pdfFile: '/images/PPT-Shiksha-Vyavastha.pdf'
  },
  {
    title: 'सांस्कृतिक चेतना अभियान',
    short: 'भारतीय परंपरा, भाषा और संस्कृति को पुनर्स्थापित करने के लिए जन-जागृति।',
    pdfFile: '/images/PPT-Shiksha-Vyavastha.pdf'
  }
];

// Images for the circle animation
const circleImages = [
  '/images/sp1.jpeg',
  '/images/sp2.jpeg', 
  '/images/sp3.jpeg'
];

const ImpactSection = () => {
  const gridRef = useRef(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-rotate images every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % circleImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleDownloadPDF = (pdfFile, title) => {
    // Create a link to download the specific PDF
    const link = document.createElement('a');
    link.href = pdfFile; 
    link.download = pdfFile.split('/').pop(); 
    link.click();
  };

  return (
    <section className="impact-section">
      <div className="impact-flex-layout">
        <div className="impact-title-container">
          <SectionTitle className="asar-section-title">असर</SectionTitle>
          
          {/* Left side: Circle with animated images */}
          <div className="impact-circle-block">
            <div className="impact-card-new circle">
              {/* Animated background images */}
              <div className="circle-image-container">
                {circleImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Impact ${index + 1}`}
                    className={`circle-bg-image ${index === currentImageIndex ? 'active' : ''}`}
                  />
                ))}
              </div>
              {/* Text overlay */}
              <div className="circle-text-overlay">
                <div className="impact-main-years">{impactData[0].title}</div>
                <div className="impact-main-desc">{impactData[0].short}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right side: 2 rows, 3 cards each */}
        <div className="impact-grid-new impact-grid-2row" ref={gridRef}>
          {[0, 1].map(row => (
            <div className="impact-row" key={row}>
              {impactData.slice(1 + row * 3, 1 + (row + 1) * 3).map((item, idx) => {
                const cardIdx = 1 + row * 3 + idx;
                return (
                  <div
                    className="impact-card-new"
                    key={cardIdx}
                  >
                    <div className="impact-card-title">{item.title}</div>
                    <div className="impact-card-short">{item.short}</div>
                    
                    {/* Individual PDF Download Button */}
                    <button 
                      onClick={() => handleDownloadPDF(item.pdfFile, item.title)}
                      className="impact-pdf-btn"
                      aria-label={`${item.title} डाउनलोड करें`}
                    >
                      <Download className="w-4 h-4" />
                      <span>PDF डाउनलोड</span>
                    </button>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
